// Centralizes the mapping of eligibility question `type` -> category so the
// decision logic never string-matches types inline. See the Benefits2 question
// rewording brief / Frontend_Implementation_Plan.md.

export const IMPAIRMENT_TYPES = [
  "Dressing",
  "EatingPreparingFood",
  "Walking",
  "Speaking",
  "Eliminating",
  "LifeSustainingTherapy",
  "MentalFunctions",
  "Hearing",
  "Vision"
] as const

// LifeSustainingTherapy is an impairment, but the brief excludes it from the
// "2+ impairments" rule that lets an applicant skip Q10.
export const LIFE_SUSTAINING_THERAPY_TYPE = "LifeSustainingTherapy"

// The conditional Q10 question. "ModerateImpairment" is the legacy type the API
// still serves for the same slot, so treat it as cumulative for compatibility.
export const CUMULATIVE_TYPES = [
  "CumulativeEffect",
  "ModerateImpairment"
] as const

export const PRACTITIONER_TYPES = ["FamilyDoctor"] as const

export const isImpairment = (type: string): boolean =>
  (IMPAIRMENT_TYPES as readonly string[]).includes(type)

export const isCumulative = (type: string): boolean =>
  (CUMULATIVE_TYPES as readonly string[]).includes(type)

export const isPractitioner = (type: string): boolean =>
  (PRACTITIONER_TYPES as readonly string[]).includes(type)

export const isLifeSustainingTherapy = (type: string): boolean =>
  type === LIFE_SUSTAINING_THERAPY_TYPE
